// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* USER LIST */

.user-select-container {
  border: 1px solid var(--border);
  border-radius: 10px;
  height: -webkit-fill-available;
  height: fill;
  height: 100%;
  margin: 0px 5px;
  background-color: #fff;
}

.user-select-innercontainer{
  margin: 10px;
}

.search-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.user-list {
  list-style: none;
  max-height: 650px;
  overflow-y: scroll;
  align-self: center;
}

.user-list-itemcontainer{
  margin: 5px 0px;
}

.user-item {
  margin-left: -40px;
  align-items: center;
  text-align: center;
  border: 1px solid var(--border);
  cursor: pointer;
}

.user-item-text-container{
  margin: 5px 0px;
}

.user-item.selected-1 {
  background-color: rgba(255, 99, 132, 0.2);
  border: 1px solid rgba(255, 99, 132, 1);
}

.user-item.selected-2 {
  background-color: rgba(54, 162, 235, 0.2);
  border: 1px solid rgba(54, 162, 235, 1);
}

.user-item.selected-3 {
  background-color: rgba(255, 206, 86, 0.2);
  border: 1px solid rgba(255, 206, 86, 1);
}

.user-item.selected-4 {
  background-color: rgba(75, 192, 192, 0.2);
  border: 1px solid rgba(75, 192, 192, 1);
}

.user-item.selected-5 {
  background-color: rgba(255, 0, 0, 0.2);
  border: 1px solid rgba(255, 0, 0, 1);
}

.user-item.selected-6 {
  background-color: rgba(0, 255, 0, 0.2);
  border: 1px solid rgba(0, 255, 0, 1);
}

.user-item.selected-7 {
  background-color: rgba(0, 0, 255, 0.2);
  border: 1px solid rgba(0, 0, 255, 1);
}

.user-item.selected-8 {
  background-color: rgba(128, 0, 128, 0.2);
  border: 1px solid rgba(128, 0, 128, 1);
}

.user-item.selected-9 {
  background-color: rgba(255, 255, 0, 0.2);
  border: 1px solid rgba(255, 255, 0, 1);
}

.user-item.selected-10 {
  background-color: rgba(255, 165, 0, 0.2);
  border: 1px solid rgba(255, 165, 0, 1);
}

.user-item.selected-11 {
  background-color: rgba(139, 69, 19, 0.2);
  border: 1px solid rgba(139, 69, 19, 1);
}

.user-item.selected-12 {
  background-color: rgba(0, 128, 0, 0.2);
  border: 1px solid rgba(0, 128, 0, 1);
}

.user-item.selected-13 {
  background-color: rgba(0, 0, 128, 0.2);
  border: 1px solid rgba(0, 0, 128, 1);
}

.user-item.selected-14 {
  background-color: rgba(128, 0, 0, 0.2);
  border: 1px solid rgba(128, 0, 0, 1);
}

.user-item.selected-15 {
  background-color: rgba(0, 255, 255, 0.2);
  border: 1px solid rgba(0, 255, 255, 1);
}

.user-item.selected-16 {
  background-color: rgba(128, 128, 0, 0.2);
  border: 1px solid rgba(128, 128, 0, 1);
}

.user-item.selected-17 {
  background-color: rgba(255, 0, 255, 0.2);
  border: 1px solid rgba(255, 0, 255, 1);
}

.user-item.selected-18 {
  background-color: rgba(128, 128, 128, 0.2);
  border: 1px solid rgba(128, 128, 128, 1);
}

.user-item.selected-19 {
  background-color: rgba(192, 192, 192, 0.2);
  border: 1px solid rgba(192, 192, 192, 1);
}

.user-item.selected-20 {
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 1);
}
.user-item.selected {
  background-color: var(--gray-10);
}

.user-item .checkmark {
  color: var(--color-forestgreen);
  float: right;
}

.selection-counter {
  background-color: var(--gray-10);
  text-align: center;
  font-weight: bold;
  height: fit-content;
  padding: 5px 0px;
}

.chart-header-container {
    display: flex;
    flex-direction: row;
    /* Align children in a row */
    justify-content: space-between;
    /* Space between title and legend */
    align-items: center;
    /* Center items vertically */
}

.chart-title-container {
    flex-grow: 1;
    /* Allows the title container to grow and fill the space */
}

/* Style for the "Gesamt" title */
.chart-title {
    margin: 0;
    /* Removes margin from the title */
    padding: 0;
    /* Add styles for the title as needed */
    font-size: 24px;
    /* Adjust the font size as needed */
    font-weight: 700;
    /* Adjust the font weight as needed */

}

/* Modify the CSS for the legend to position it in the top middle */
.chart-legend-container {
    /* Center legend in the middle of the container */
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    /* Align the legend to the top */
    /* Adjust the top margin as needed */
    /* Add other styles as needed */
}

/* Ensure the dots and legend text are aligned properly */
.legend-item {
    display: flex;
    align-items: center;
    margin-right: 2%;
    margin-left: 2%;
    margin-bottom: 2%;
    /* Adjust spacing between legend items */
}

.dot {
    height: 10px;
    /* Adjust as needed */
    width: 10px;
    /* Adjust as needed */
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
    /* Space between dot and text */
}

/* Define colors for the dots */
.dot-ist {
    background-color: #347ae2;
}

.dot-lv {
    background-color: #ff9500;
}

.dot-ziel {
    background-color: #53ca43;
}

.singleContent-row-container-profiles {
    width: 100%;
    /* Adjust the width as needed */
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
}

/* Radial Chart */

.radial-chart-gesamtbewertung-container {
    position: relative;
    align-self: center;
    min-height: 300px;
    padding: -5%;
    margin-bottom: -40px;
}

.radial-chart-gesamtbewertung-description {
    text-align: center;
    font-size: 24px;
    /* Center the text */
    width: 100%;
    /* Ensure the div takes up the full width */
    /* ...other styles... */
}


/*USER PROFILES*/
.usercard-border{
  position: relative;

  border-radius: 20px;
  border: 1px solid #727272;
  background: #FFF;
  cursor: pointer;
  
  min-width: 250px;
}

.usercard-inner-container{
  margin: 15px;
}


.user-profile-image-container {
    /* Placeholder for image container styles */
    padding-right: 10px;
}

.user-profile-image {
  width: 50px; /* Adjust as needed */
  height: 50px; /* Adjust as needed */
  border-radius: 50%; /* Circle image */
}

.user-profile-header{
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 20px;
}

.user-nameSection-container{
  position: relative;
  margin-left: 10px;
}

.user-profile-name {
  width: fit-content;
  font-weight: bold;
  white-space: nowrap;
}

.user-profile-role {
  color: var(--rolecolor); /* Adjust color as needed */
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 16px; /* 200% */
}

.user-profile-choice-button{
  align-self: right;
  margin-left: auto;
}

.user-profile-body{
  min-width: 100%;
}

.user-profile-score-value {
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 16px; /* 160% */
  letter-spacing: 1.5px;
}

.user-profile-score-bars {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
  gap: 4px; /* 2px on each side of the score-bar */
}

.score-bar {
  width: calc(10% - 4px); /* 10% minus the 2px gap on each side */
  height: 8px;
  margin: 0;
  box-sizing: border-box;
}

/* Define colors for score values 1 to 5 */
.score-bar-1 { background: var(--assessment-lv1); } /* Red */
.score-bar-2 { background: var(--assessment-lv2); } /* Orange */
.score-bar-3 { background: var(--assessment-lv3); } /* Yellow */
.score-bar-4 { background: var(--assessment-lv4); } /* Light Green */
.score-bar-5 { background: var(--assessment-lv5); } /* Green */

.greyed-out {
  background-color: #bababa; /* or any grey shade you prefer */
}
.usercard-selected {
  background-color: rgb(211, 243, 255); 
} `, "",{"version":3,"sources":["webpack://./src/widgets/BewertungGruppenAuswertungWidgets.css"],"names":[],"mappings":";AACA,cAAc;;AAEd;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,8BAAY;EAAZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,mCAAmC;IACnC,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,0DAA0D;AAC9D;;AAEA,iCAAiC;AACjC;IACI,SAAS;IACT,kCAAkC;IAClC,UAAU;IACV,uCAAuC;IACvC,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,qCAAqC;;AAEzC;;AAEA,mEAAmE;AACnE;IACI,iDAAiD;IACjD,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC;IAChC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,2CAA2C;IAC3C,uBAAuB;AAC3B;;;AAGA,gBAAgB;AAChB;EACE,kBAAkB;;EAElB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;;AAGA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,YAAY,EAAE,qBAAqB;EACnC,kBAAkB,EAAE,iBAAiB;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB,EAAE,2BAA2B;EACpD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,QAAQ,EAAE,sCAAsC;AAClD;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C,eAAe,iCAAiC,EAAE,EAAE,QAAQ;AAC5D,eAAe,iCAAiC,EAAE,EAAE,WAAW;AAC/D,eAAe,iCAAiC,EAAE,EAAE,WAAW;AAC/D,eAAe,iCAAiC,EAAE,EAAE,gBAAgB;AACpE,eAAe,iCAAiC,EAAE,EAAE,UAAU;;AAE9D;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;AACA;EACE,oCAAoC;AACtC","sourcesContent":["\r\n/* USER LIST */\r\n\r\n.user-select-container {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  height: fill;\r\n  height: 100%;\r\n  margin: 0px 5px;\r\n  background-color: #fff;\r\n}\r\n\r\n.user-select-innercontainer{\r\n  margin: 10px;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-bottom: 8px;\r\n  box-sizing: border-box;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.user-list {\r\n  list-style: none;\r\n  max-height: 650px;\r\n  overflow-y: scroll;\r\n  align-self: center;\r\n}\r\n\r\n.user-list-itemcontainer{\r\n  margin: 5px 0px;\r\n}\r\n\r\n.user-item {\r\n  margin-left: -40px;\r\n  align-items: center;\r\n  text-align: center;\r\n  border: 1px solid var(--border);\r\n  cursor: pointer;\r\n}\r\n\r\n.user-item-text-container{\r\n  margin: 5px 0px;\r\n}\r\n\r\n.user-item.selected-1 {\r\n  background-color: rgba(255, 99, 132, 0.2);\r\n  border: 1px solid rgba(255, 99, 132, 1);\r\n}\r\n\r\n.user-item.selected-2 {\r\n  background-color: rgba(54, 162, 235, 0.2);\r\n  border: 1px solid rgba(54, 162, 235, 1);\r\n}\r\n\r\n.user-item.selected-3 {\r\n  background-color: rgba(255, 206, 86, 0.2);\r\n  border: 1px solid rgba(255, 206, 86, 1);\r\n}\r\n\r\n.user-item.selected-4 {\r\n  background-color: rgba(75, 192, 192, 0.2);\r\n  border: 1px solid rgba(75, 192, 192, 1);\r\n}\r\n\r\n.user-item.selected-5 {\r\n  background-color: rgba(255, 0, 0, 0.2);\r\n  border: 1px solid rgba(255, 0, 0, 1);\r\n}\r\n\r\n.user-item.selected-6 {\r\n  background-color: rgba(0, 255, 0, 0.2);\r\n  border: 1px solid rgba(0, 255, 0, 1);\r\n}\r\n\r\n.user-item.selected-7 {\r\n  background-color: rgba(0, 0, 255, 0.2);\r\n  border: 1px solid rgba(0, 0, 255, 1);\r\n}\r\n\r\n.user-item.selected-8 {\r\n  background-color: rgba(128, 0, 128, 0.2);\r\n  border: 1px solid rgba(128, 0, 128, 1);\r\n}\r\n\r\n.user-item.selected-9 {\r\n  background-color: rgba(255, 255, 0, 0.2);\r\n  border: 1px solid rgba(255, 255, 0, 1);\r\n}\r\n\r\n.user-item.selected-10 {\r\n  background-color: rgba(255, 165, 0, 0.2);\r\n  border: 1px solid rgba(255, 165, 0, 1);\r\n}\r\n\r\n.user-item.selected-11 {\r\n  background-color: rgba(139, 69, 19, 0.2);\r\n  border: 1px solid rgba(139, 69, 19, 1);\r\n}\r\n\r\n.user-item.selected-12 {\r\n  background-color: rgba(0, 128, 0, 0.2);\r\n  border: 1px solid rgba(0, 128, 0, 1);\r\n}\r\n\r\n.user-item.selected-13 {\r\n  background-color: rgba(0, 0, 128, 0.2);\r\n  border: 1px solid rgba(0, 0, 128, 1);\r\n}\r\n\r\n.user-item.selected-14 {\r\n  background-color: rgba(128, 0, 0, 0.2);\r\n  border: 1px solid rgba(128, 0, 0, 1);\r\n}\r\n\r\n.user-item.selected-15 {\r\n  background-color: rgba(0, 255, 255, 0.2);\r\n  border: 1px solid rgba(0, 255, 255, 1);\r\n}\r\n\r\n.user-item.selected-16 {\r\n  background-color: rgba(128, 128, 0, 0.2);\r\n  border: 1px solid rgba(128, 128, 0, 1);\r\n}\r\n\r\n.user-item.selected-17 {\r\n  background-color: rgba(255, 0, 255, 0.2);\r\n  border: 1px solid rgba(255, 0, 255, 1);\r\n}\r\n\r\n.user-item.selected-18 {\r\n  background-color: rgba(128, 128, 128, 0.2);\r\n  border: 1px solid rgba(128, 128, 128, 1);\r\n}\r\n\r\n.user-item.selected-19 {\r\n  background-color: rgba(192, 192, 192, 0.2);\r\n  border: 1px solid rgba(192, 192, 192, 1);\r\n}\r\n\r\n.user-item.selected-20 {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border: 1px solid rgba(0, 0, 0, 1);\r\n}\r\n.user-item.selected {\r\n  background-color: var(--gray-10);\r\n}\r\n\r\n.user-item .checkmark {\r\n  color: var(--color-forestgreen);\r\n  float: right;\r\n}\r\n\r\n.selection-counter {\r\n  background-color: var(--gray-10);\r\n  text-align: center;\r\n  font-weight: bold;\r\n  height: fit-content;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.chart-header-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    /* Align children in a row */\r\n    justify-content: space-between;\r\n    /* Space between title and legend */\r\n    align-items: center;\r\n    /* Center items vertically */\r\n}\r\n\r\n.chart-title-container {\r\n    flex-grow: 1;\r\n    /* Allows the title container to grow and fill the space */\r\n}\r\n\r\n/* Style for the \"Gesamt\" title */\r\n.chart-title {\r\n    margin: 0;\r\n    /* Removes margin from the title */\r\n    padding: 0;\r\n    /* Add styles for the title as needed */\r\n    font-size: 24px;\r\n    /* Adjust the font size as needed */\r\n    font-weight: 700;\r\n    /* Adjust the font weight as needed */\r\n\r\n}\r\n\r\n/* Modify the CSS for the legend to position it in the top middle */\r\n.chart-legend-container {\r\n    /* Center legend in the middle of the container */\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    /* Align the legend to the top */\r\n    /* Adjust the top margin as needed */\r\n    /* Add other styles as needed */\r\n}\r\n\r\n/* Ensure the dots and legend text are aligned properly */\r\n.legend-item {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-right: 2%;\r\n    margin-left: 2%;\r\n    margin-bottom: 2%;\r\n    /* Adjust spacing between legend items */\r\n}\r\n\r\n.dot {\r\n    height: 10px;\r\n    /* Adjust as needed */\r\n    width: 10px;\r\n    /* Adjust as needed */\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin-right: 5px;\r\n    /* Space between dot and text */\r\n}\r\n\r\n/* Define colors for the dots */\r\n.dot-ist {\r\n    background-color: #347ae2;\r\n}\r\n\r\n.dot-lv {\r\n    background-color: #ff9500;\r\n}\r\n\r\n.dot-ziel {\r\n    background-color: #53ca43;\r\n}\r\n\r\n.singleContent-row-container-profiles {\r\n    width: 100%;\r\n    /* Adjust the width as needed */\r\n    overflow-x: auto;\r\n    white-space: nowrap;\r\n    display: flex;\r\n}\r\n\r\n/* Radial Chart */\r\n\r\n.radial-chart-gesamtbewertung-container {\r\n    position: relative;\r\n    align-self: center;\r\n    min-height: 300px;\r\n    padding: -5%;\r\n    margin-bottom: -40px;\r\n}\r\n\r\n.radial-chart-gesamtbewertung-description {\r\n    text-align: center;\r\n    font-size: 24px;\r\n    /* Center the text */\r\n    width: 100%;\r\n    /* Ensure the div takes up the full width */\r\n    /* ...other styles... */\r\n}\r\n\r\n\r\n/*USER PROFILES*/\r\n.usercard-border{\r\n  position: relative;\r\n\r\n  border-radius: 20px;\r\n  border: 1px solid #727272;\r\n  background: #FFF;\r\n  cursor: pointer;\r\n  \r\n  min-width: 250px;\r\n}\r\n\r\n.usercard-inner-container{\r\n  margin: 15px;\r\n}\r\n\r\n\r\n.user-profile-image-container {\r\n    /* Placeholder for image container styles */\r\n    padding-right: 10px;\r\n}\r\n\r\n.user-profile-image {\r\n  width: 50px; /* Adjust as needed */\r\n  height: 50px; /* Adjust as needed */\r\n  border-radius: 50%; /* Circle image */\r\n}\r\n\r\n.user-profile-header{\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.user-nameSection-container{\r\n  position: relative;\r\n  margin-left: 10px;\r\n}\r\n\r\n.user-profile-name {\r\n  width: fit-content;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n}\r\n\r\n.user-profile-role {\r\n  color: var(--rolecolor); /* Adjust color as needed */\r\n  font-size: 10px;\r\n  font-style: normal;\r\n  font-weight: 800;\r\n  line-height: 16px; /* 200% */\r\n}\r\n\r\n.user-profile-choice-button{\r\n  align-self: right;\r\n  margin-left: auto;\r\n}\r\n\r\n.user-profile-body{\r\n  min-width: 100%;\r\n}\r\n\r\n.user-profile-score-value {\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 800;\r\n  line-height: 16px; /* 160% */\r\n  letter-spacing: 1.5px;\r\n}\r\n\r\n.user-profile-score-bars {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-top: 5px;\r\n  gap: 4px; /* 2px on each side of the score-bar */\r\n}\r\n\r\n.score-bar {\r\n  width: calc(10% - 4px); /* 10% minus the 2px gap on each side */\r\n  height: 8px;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Define colors for score values 1 to 5 */\r\n.score-bar-1 { background: var(--assessment-lv1); } /* Red */\r\n.score-bar-2 { background: var(--assessment-lv2); } /* Orange */\r\n.score-bar-3 { background: var(--assessment-lv3); } /* Yellow */\r\n.score-bar-4 { background: var(--assessment-lv4); } /* Light Green */\r\n.score-bar-5 { background: var(--assessment-lv5); } /* Green */\r\n\r\n.greyed-out {\r\n  background-color: #bababa; /* or any grey shade you prefer */\r\n}\r\n.usercard-selected {\r\n  background-color: rgb(211, 243, 255); \r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
